import React from 'react';
import logoImage from './lugu.jpg';

export default function Logo({ size = 'default', isDarkMode = false }) {
  const sizes = {
    small: { width: '40px', padding: '0.2rem' },
    default: { width: '120px', padding: '0.4rem' },
    large: { width: '280px', padding: '0.8rem' }
  };
  
  const currentSize = sizes[size] || sizes.default;
  
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'transform 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <div
        style={{
          width: currentSize.width,
          height: currentSize.width,
          borderRadius: '50%',
          background: 'white',
          border: '2px solid rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: currentSize.padding,
          boxShadow: isDarkMode 
            ? '0 4px 15px rgba(0, 0, 0, 0.3)' 
            : '0 4px 15px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <img
          src={logoImage}
          alt="IEI Students' Chapter CSE Logo"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            display: 'block',
            padding: '0.2rem'
          }}
        />
      </div>
    </div>
  );
}

